import React from 'react';
import Layout from "../layouts/layout";
import Index from '../components/sampleTest';

export default function SampleTest() {

  return (
    <>
      <Layout>
        <Index />
      </Layout>
    </>
  );
}